import { Accordion as BaseAccordion } from "@base-ui/react/accordion";
import { ChevronDown } from "lucide-react";
import { cn } from "./cn";

/** Themed, accessible disclosure group built on Base UI Accordion. */
export const Accordion = {
    Root: function Root({
        className,
        ...props
    }: React.ComponentPropsWithoutRef<typeof BaseAccordion.Root>) {
        return <BaseAccordion.Root className={cn(className as string)} {...props} />;
    },
    Item: function Item({
        className,
        ...props
    }: React.ComponentPropsWithoutRef<typeof BaseAccordion.Item>) {
        return <BaseAccordion.Item className={cn(className as string)} {...props} />;
    },
    Header: function Header({
        className,
        ...props
    }: React.ComponentPropsWithoutRef<typeof BaseAccordion.Header>) {
        return <BaseAccordion.Header className={cn("m-0", className as string)} {...props} />;
    },
    Trigger: function Trigger({
        className,
        children,
        ...props
    }: React.ComponentPropsWithoutRef<typeof BaseAccordion.Trigger>) {
        return (
            <BaseAccordion.Trigger
                className={cn(
                    "group flex w-full items-center gap-3 border-0 bg-transparent p-0 text-left " +
                        "text-fg outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-inset",
                    className as string,
                )}
                {...props}
            >
                {children}
                <ChevronDown
                    className="accordion-chevron size-4 shrink-0 text-muted transition-transform duration-200 group-data-[open]:rotate-180"
                    aria-hidden="true"
                />
            </BaseAccordion.Trigger>
        );
    },
    Panel: function Panel({
        className,
        ...props
    }: React.ComponentPropsWithoutRef<typeof BaseAccordion.Panel>) {
        return (
            <BaseAccordion.Panel
                className={cn(
                    "h-[var(--accordion-panel-height)] overflow-hidden transition-[height] duration-200 " +
                        "data-[starting-style]:h-0 data-[ending-style]:h-0",
                    className as string,
                )}
                {...props}
            />
        );
    },
};
